var map = {
	"./part3/voice/question0_en.wav": "d83a",
	"./part3/voice/question1_en.wav": "88ee",
	"./part3/voice/question1_en_b.wav": "52ba",
	"./part3/voice/question2_en.wav": "ed64",
	"./part3/voice/question3_en.wav": "9516",
	"./part4/voice/question0_en.wav": "0392",
	"./part4/voice/question1_en.wav": "065d",
	"./part4/voice/question2_en.wav": "247c",
	"./part4/voice/question3_en.wav": "5c56",
	"./part5/voice/question1_en.wav": "0b11"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "752b";